(function () {
  var COOKIENAME = 'TEScookieLawCookie';
  var COOKIEINFO = 'Welcome, this site uses cookies. <a href="https://www.tes.com/us/privacy-policy" style="color:white;text-decoration: underline">Read our privacy policy</a>';
  var COOKIEINFO_SHORT = 'Welcome, this site uses <a href="https://www.tes.com/us/privacy-policy" style="color:white;">cookies</a>.';

  var HOOK_CLASS = 'cookielaw-panel';
  var PANEL_CLASSES = HOOK_CLASS + ' text-center padding-top-xs padding-bottom-xs padding-left-lg padding-right-lg';
  var INFO_CLASSES = 'text--white padding-right-sm padding-left-sm';
  var CLOSE_CLASSES = 'padding-left-lg';
  var CLOSE_CLASSES_MOBILE = 'tes-btn tes-btn--outline tes-btn--block';

  if (!Cookies) return;

  function createPanel() {
    if (document.querySelector('.' + HOOK_CLASS)) return;
    var wrapper = document.createElement('div');
    var isSmallScreen = Boolean(document.documentElement.clientWidth < 600);
    var anchoredTo = isSmallScreen ? 'top' : 'bottom';
    wrapper.className = PANEL_CLASSES;
    wrapper.style.backgroundColor = '#44A4F6';
    wrapper.style.position = 'fixed';
    wrapper.style[anchoredTo] = '0';
    wrapper.style.width = '100%';
    wrapper.style.zIndex = '101';
    wrapper.style.transition = 'transform ease-out 200ms';

    var info = document.createElement('span');
    info.className = INFO_CLASSES;
    info.innerHTML = isSmallScreen ? COOKIEINFO_SHORT : COOKIEINFO;
    wrapper.appendChild(info);

    var close = document.createElement('span');
    close.innerHTML = '<span class="hidden-xs"><a href="#" style="color:white;" class="' + CLOSE_CLASSES + '">Close</a> <i style="cursor:pointer;position:relative;top:-1px;" class="icon-close-button icon-white"></i></span><div class="visible-xs padding-top-sm"><span class="' + CLOSE_CLASSES_MOBILE + '">Close</span></div>';
    wrapper.appendChild(close);

    document.body.insertBefore(wrapper, document.body.firstChild);
    if (isSmallScreen) {
      var wrapperHeight = wrapper.offsetHeight;
      var currentBodyPadding = window.getComputedStyle(document.documentElement, null).getPropertyValue('padding-top');
      document.documentElement.style.paddingTop = wrapperHeight + 'px';
    }

    close.addEventListener('click', destroyPanel);

    function destroyPanel(evt) {
      evt.preventDefault();

      var topLevelDomain = window.location.hostname.split('.');
      topLevelDomain.shift();
      topLevelDomain = topLevelDomain.join('.');
      Cookies.set(COOKIENAME, 'true', {
        domain: topLevelDomain,
        expires: '01/01/2030'
      });

      if (isSmallScreen) {
        document.documentElement.style.paddingTop = currentBodyPadding;
        wrapper.parentNode.removeChild(wrapper);
      } else {
        wrapper.style.transform = 'translateY(100%)';
        setTimeout(function () {
          wrapper.parentNode.removeChild(wrapper);
        }, 600);
      }
    }
  }

  var alreadyLoggedIn = Cookies.get('TESCookieUser');
  var cookieLawCookie = Cookies.get(COOKIENAME);
  var siteCountry = Cookies.get('siteCountry') || 'gb';
  var isGB = siteCountry.toLowerCase() === 'gb';
  if (isGB && !cookieLawCookie && !alreadyLoggedIn) {
    window.addEventListener('load', function load() {
      window.removeEventListener("load", load, false);
      createPanel();
    });
  }
}());
